// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"de2ddd08","453":"93b3ac6f"}[chunkId] + ".chunk.js";
};